export const RECOMMENDATIONS_API_TYPES = {
  SET_OPEN_ATTACHMENT_SELECTOR_MODAL: "SET_OPEN_ATTACHMENT_SELECTOR_MODAL",
  SET_CLOSE_MODAL: "SET_CLOSE_MODAL",
  SET_CHANGE_MODAL: "SET_CHANGE_MODAL",
  SET_ADD_PROCESS_DATA: "SET_ADD_PROCESS_DATA",
  SET_EDIT_PROCESS_DATA: "SET_EDIT_PROCESS_DATA",
  SET_WORKFLOW_RESULT: "SET_WORKFLOW_RESULT",
  SET_STOP_CURRENT_PROCESSING: "SET_STOP_CURRENT_PROCESSING",
  SET_SHOW_PROCESS_STATUS_CARD: "SET_SHOW_PROCESS_STATUS_CARD",
  SET_WORKFLOW_OUTPUT: "SET_WORKFLOW_OUTPUT",
  SET_WORKFLOW_NO_CONTENT: "SET_WORKFLOW_NO_CONTENT",
  RESET_WORKFLOW_STATE: "RESET_WORKFLOW_STATE",
};
